module.exports = __webpack_public_path__ + "teqbahn-assets/media/25.45acddf5.png";